export default __webpack_public_path__ + "static/media/partner-6.80f60cf1.png";